import Rollbar, { Configuration } from 'rollbar'
import { getEnvironment, getRollbarToken } from './environment'

const isEnabled =
  getEnvironment() === 'production' || getEnvironment() === 'staging'
const codeVersion = process.env.NEXT_PUBLIC_CODE_VERSION || 'latest'

export const rollbarConfig: Configuration = {
  environment: getEnvironment(),
  accessToken: getRollbarToken(),
  enabled: isEnabled,
  captureIp: 'anonymize',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
        code_version: codeVersion,
      },
    },
  },
}

const rollbar = new Rollbar(rollbarConfig)

export default rollbar
